import { Fragment } from 'react';
import useIsMobile from '@/hooks/useIsMobile';
import * as S from './style';

const executiveGroups = [
	{
		role: '회장',
		members: [{ name: '이재원', org: '부산대학교 약학과' }],
	},
	{
		role: '부회장',
		members: [
			{ name: '이승재', org: '한국과학기술원 생명과학과' },
			{ name: '권은수', org: '한국생명공학연구원 노화치료융합연구단' },
			{ name: '서영록', org: '동국대학교 생명과학과' },
		],
	},
	{
		role: '감사',
		members: [
			{ name: '최은경', org: '한림대학교 일송생명과학연구소' },
			{ name: '민경진', org: '인하대학교 생명과학과' },
		],
	},
	{
		role: '운영위원장',
		members: [{ name: '이영삼', org: '대구경북과학기술원 뉴바이올로지학과' }],
	},
	{
		role: '운영위원',
		members: [
			{ name: '정기웅', org: '부산대학교 약학과' },
			{ name: '함정훈', org: '한국식품연구원' },
		],
	},
	{
		role: '총무위원장',
		members: [{ name: '조경아', org: '전남대학교 의과대학 생화학교실' }],
	},
	{
		role: '총무위원',
		members: [
			{ name: '김은수', org: '부산대학교 약학대학 제약학과' },
			{ name: '이인혜', org: '이화여대 생명과학과' },
			{ name: '윤미섭', org: '가천대학교 의과대학 의예과' },
			{ name: '박윤정', org: '이화여대 식품영양학과' },
		],
	},
	{
		role: '학술위원장',
		members: [{ name: '서재명', org: '한국과학기술연구원 의과학대학원' }],
	},
	{
		role: '학술위원',
		members: [
			{ name: '이윤실', org: '서울대학교 치의과학과' },
			{ name: '김진홍', org: '서울대학교 생명과학부' },
			{ name: '장지원', org: '포항공과대학교 생명과학과' },
			{ name: '김정수', org: '조선대학교 의생명과학과' },
			{ name: '전옥희', org: '고려대학교 의과대학 융합의학교실' },
			{ name: '허지연', org: '아주대학교 생명과학과' },
			{ name: '유승진', org: '중앙대학교 의과대학 생화학교실' },
			{ name: '양재현', org: '한국과학기술원 뇌인지과학과' },
			{ name: '류동렬', org: '광주과학기술원 의생명공학과' },
		],
	},
	{
		role: '기획위원장',
		members: [{ name: '김석호', org: '동아대학교 의약생명공학과' }],
	},
	{
		role: '기획위원',
		members: [
			{ name: '양용렬', org: '한국생명공학연구원 노화치료융합연구단' },
			{ name: '신태환', org: '동아대학교 바이오메디컬학과' },
		],
	},
	{
		role: '출판위원장',
		members: [{ name: '차혁진', org: '서울대학교 약학대학 제약학과' }],
	},
	{
		role: '출판위원',
		members: [
			{ name: '권옥선', org: '한국생명공학연구원 유전자 세포치료전략연구단' },
			{ name: '박현정', org: '서울대학교 수의학과' },
		],
	},
	{
		role: '홍보위원장',
		members: [{ name: '이광표', org: '한국생명공학연구원 노화융합연구단' }],
	},
	{
		role: '홍보위원',
		members: [
			{ name: '이윤일', org: '대구경북과학기술원 바이오메디컬연구부' },
			{ name: '김유미', org: '이음바이오/울산과학기술원' },
			{ name: '신옥', org: '고려대학교 의과대학 구로병원' },
		],
	},
	{
		role: '재무위원장',
		members: [{ name: '표종옥', org: '울산대학교/PYO Biotech' }],
	},
	{
		role: '재무위원',
		members: [{ name: '신동욱', org: '건국대학교 바이오융합과학부' }],
	},
	{
		role: '국제위원장',
		members: [{ name: '서진수', org: '연세대학교 시스템생물학과' }],
	},
	{
		role: '국제위원',
		members: [
			{ name: '강찬희', org: '서울대학교 생명과학부' },
			{ name: '김천아', org: '한국생명공학연구원 노화치료융합연구단' },
			{ name: '이성배', org: '대구경북과학기술원 뇌과학과' },
		],
	},
	{
		role: '기금위원장',
		members: [{ name: '권기선', org: '(주)아벤티' }],
	},
	{
		role: '자문위원장',
		members: [{ name: '민경진', org: '인하대학교 생명과학과' }],
	},
	{
		role: '자문위원',
		members: [
			{ name: '박중진', org: '고려대학교 의과대학 생리학교실' },
			{ name: '최은경', org: '한림대학교 일송생명과학연구소' },
		],
	},
	{
		role: '포상위원장',
		members: [{ name: '박태준', org: '아주대학교 의과대학 생화학교실' }],
	},
	{
		role: '포상위원',
		members: [
			{ name: '이재원', org: '부산대학교 약학대학' },
			{ name: '이승재', org: '한국과학기술원 생명과학과' },
			{ name: '권은수', org: '한국생명공학연구원 노화융합연구단' },
			{ name: '이영삼', org: '대구경북과학기술원 뉴바이올로지학과' },
			{ name: '김석호', org: '동아대학교 의약생명공학과' },
		],
	},
];
const ExecutiveList = () => {
	const isMobile = useIsMobile(900);
	return (
		<S.ExecutiveListContainer>
			<S.Description>
				한국노화학회는 다양한 분야의
				<br style={isMobile ? { display: 'none' } : {}} />
				인재들을 모아 <br style={isMobile ? {} : { display: 'none' }} />
				현재의 한국노화학회를 이끌어 나가고 있습니다.
			</S.Description>
			<S.Table>
				<S.TableHeadCell>직책</S.TableHeadCell>
				<S.TableHeadCell>성명</S.TableHeadCell>
				<S.TableHeadCell>소속</S.TableHeadCell>
				{executiveGroups.map((group) => (
					<Fragment key={group.role}>
						<S.TableCell className="point min-height" style={{ gridRow: `span ${group.members.length}` }}>
							{group.role}
						</S.TableCell>
						{group.members.map((member, index) => (
							<Fragment key={`${group.role}-${member.name}-${index}`}>
								<S.TableCell className="min-height">{member.name}</S.TableCell>
								<S.TableCell className="min-height">{member.org}</S.TableCell>
							</Fragment>
						))}
					</Fragment>
				))}
			</S.Table>
		</S.ExecutiveListContainer>
	);
};
export default ExecutiveList;
